import React from "react";
import { Toolbar } from "../Toolbar";
import { Button, Intent } from "@blueprintjs/core";
import styles from "./CashOutOverview.module.scss";

function CashOutPageHeader({
  setIsDialogOpen,
  setIsTopOffDialogOpen,
  amountDue
}) {
  return (
    <Toolbar title="Cash Out" className={styles.reportingPageHeader}>
      {/**
      <Button
        text="Top Off"
        className={styles.btnTopOff}
        onClick={() => setIsTopOffDialogOpen(true)}
        intent={Intent.NONE}
      />
       **/}
      <Button
        text="Cash Out"
        disabled={!amountDue}
        onClick={() => setIsDialogOpen(true)}
        intent={Intent.PRIMARY}
      />
    </Toolbar>
  );
}

export default CashOutPageHeader;
